import { render, staticRenderFns } from "./checkbox-consent.vue?vue&type=template&id=f4547182&scoped=true"
import script from "./checkbox-consent.vue?vue&type=script&lang=js"
export * from "./checkbox-consent.vue?vue&type=script&lang=js"
import style0 from "./checkbox-consent.vue?vue&type=style&index=0&id=f4547182&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4547182",
  null
  
)

export default component.exports